export const FIXED_ADD_TO_ORDER_AND_QUANTITY_HEIGHT = '5.15rem';
export const FIXED_TOAST_HEIGHT = '3.15rem';
